import { render } from "./CommonSupport.vue?vue&type=template&id=7ad0057d&scoped=true"
import script from "./CommonSupport.vue?vue&type=script&lang=js"
export * from "./CommonSupport.vue?vue&type=script&lang=js"

import "./CommonSupport.vue?vue&type=style&index=0&id=7ad0057d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad0057d"]])

export default __exports__